import _extends from "@babel/runtime/helpers/esm/extends";
import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
import _inheritsLoose from "@babel/runtime/helpers/esm/inheritsLoose";
import PropTypes from 'prop-types';
import React from 'react';

var _React$createContext = React.createContext(new Map()),
    Provider = _React$createContext.Provider,
    Consumer = _React$createContext.Consumer;

var ThemeProvider =
/*#__PURE__*/
function (_React$Component) {
  _inheritsLoose(ThemeProvider, _React$Component);

  function ThemeProvider() {
    var _this;

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _React$Component.call.apply(_React$Component, [this].concat(args)) || this;
    _this.prefixes = new Map();
    Object.entries(_this.props.prefixes).forEach(function (_ref) {
      var key = _ref[0],
          value = _ref[1];

      _this.prefixes.set(key, value);
    });
    return _this;
  }

  var _proto = ThemeProvider.prototype;

  _proto.render = function render() {
    return React.createElement(Provider, {
      value: this.prefixes
    }, this.props.children);
  };

  return ThemeProvider;
}(React.Component);

ThemeProvider.propTypes = {
  prefixes: PropTypes.object.isRequired
};

function createBootstrapComponent(Component, opts) {
  if (typeof opts === 'string') opts = {
    prefix: opts
  };
  var isClassy = Component.prototype && Component.prototype.isReactComponent; // If it's a functional component make sure we don't break it with a ref

  var _opts = opts,
      prefix = _opts.prefix,
      _opts$forwardRefAs = _opts.forwardRefAs,
      forwardRefAs = _opts$forwardRefAs === void 0 ? isClassy ? 'ref' : 'innerRef' : _opts$forwardRefAs;
  var name = Component.displayName || Component.name; // This looks like a function component but it's not,
  // it's passed to forwardRef directly, and named for the dev-tools
  // eslint-disable-next-line react/prop-types

  function forwardRef(_ref2, ref) {
    var bsPrefix = _ref2.bsPrefix,
        props = _objectWithoutPropertiesLoose(_ref2, ["bsPrefix"]);

    props[forwardRefAs] = ref;
    return React.createElement(Consumer, null, function (prefixes) {
      return React.createElement(Component, _extends({}, props, {
        bsPrefix: bsPrefix || prefixes.get(prefix) || prefix
      }));
    });
  }

  forwardRef.displayName = "Bootstrap(" + name + ")";
  return React.forwardRef(forwardRef);
}

export { createBootstrapComponent, Consumer as ThemeConsumer };
export default ThemeProvider;